module.exports = __webpack_public_path__ + "img/5-vintage.a337338.png";


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/assets/5-vintage.png
// module id = Kw7n
// module chunks = 1